import { render, staticRenderFns } from "./ProjectComplaints.vue?vue&type=template&id=7537478f&scoped=true&"
import script from "./ProjectComplaints.vue?vue&type=script&lang=js&"
export * from "./ProjectComplaints.vue?vue&type=script&lang=js&"
import style0 from "./ProjectComplaints.vue?vue&type=style&index=0&id=7537478f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7537478f",
  null
  
)

export default component.exports